var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "white",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399 4298 c-20 -11 -46 -37 -57 -57 -11 -20 -93 -257 -183 -528 l-163 -491 85 -597 c70 -486 89 -601 105 -623 19 -25 541 -426 668 -512 l58 -40 312 0 312 0 64 -66 c36 -36 79 -72 97 -80 22 -10 74 -14 166 -14 l134 0 147 -220 c98 -148 157 -227 179 -240 29 -18 51 -20 235 -20 213 0 235 4 275 48 10 10 48 111 86 223 l68 204 96 5 c114 6 138 19 182 103 l30 57 245 0 245 0 225 -226 c124 -124 237 -232 252 -240 32 -17 86 -18 125 -3 15 6 108 90 205 187 190 188 217 227 204 294 -3 18 -60 114 -126 213 -158 237 -158 218 -6 374 63 64 120 129 125 144 7 17 11 121 11 262 l0 235 160 320 160 321 0 356 0 356 -25 42 c-34 59 -78 75 -206 75 -67 0 -112 -5 -137 -15 -25 -11 -162 -140 -422 -400 l-385 -385 -72 0 -72 0 -10 38 c-6 20 -37 145 -70 276 -33 134 -68 250 -78 264 -41 55 -72 62 -269 62 l-182 0 -4 114 c-3 128 -14 153 -78 187 -33 18 -89 19 -1355 19 l-1320 0 -36 -22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsa);
export default __webpack_public_path__ + "static/media/usa.f475dcfc60ef7f35b660179da58e57b2.svg";
export { ForwardRef as ReactComponent };